const scheduledServicesCalendarCalendar = {
  allDay: 'Todo el día',
  today: 'Hoy',
  month: 'Mes',
  week: 'Semana',
  day: 'Día',
  agenda: 'Agenda',
  date: 'Fecha',
  time: 'Hora',
  event: 'Evento',
  showMore: '+ Eventos',
};

export default scheduledServicesCalendarCalendar;
